import Vue from 'vue';
import App from './App.vue';
import router from './routers/index';
import store from '@/stores/index';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/main.styl';
import Bus from "@/bus/index";
import Cookies from 'vue-cookies';
import 'animate.css';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import fa from "element-ui/src/locale/lang/fa";

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(Viewer);
Viewer.setDefaults({
  toolbar: false,
});
Vue.use(Cookies);

Object.defineProperties(Vue.prototype, {
  $bus: {
    get() {
      return Bus;
    }
  }
});

function isIE() {
  const theUA = window.navigator.userAgent.toLowerCase();
  if ((theUA.match(/msie\s\d+/) && theUA.match(/msie\s\d+/)[0]) || (theUA.match(/trident\/\d+/) && theUA.match(/trident\/\d+/)[0])) {
    let ieVersion
    if (theUA.match(/msie\s\d+/)) {
      ieVersion = theUA.match(/msie\s\d+/)[0].match(/\d+/)[0]
    } else {
      ieVersion = theUA.match(/trident\/\d+/)[0].split('/')[1];
    }
    if (ieVersion < 9) {
      return true;
    }
  }
  return false;
}

Vue.prototype.$isIE = isIE();

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
